import { motion } from "motion/react";
import { useCardRotation, type SwipeDirection } from "../../hooks/useCardRotation";

interface DraggableContainerProps {
  children: React.ReactNode;
  onSwipe?: (direction: SwipeDirection) => void;
  className?: string;
}

export function DraggableContainer({
  children,
  onSwipe,
  className,
}: DraggableContainerProps) {
  const { x, y, rotateX, rotateY, handleDragEnd } =
    useCardRotation(onSwipe);

  return (
    <motion.div
      className={className}
      style={{ x, y, rotateX, rotateY }}
      drag
      dragConstraints={{ top: 0, right: 0, bottom: 0, left: 0 }}
      dragElastic={0.6}
      whileTap={{ cursor: "grabbing" }}
      onDragEnd={handleDragEnd}
    >
      {children}
    </motion.div>
  );
}
